import classNames from 'classnames';
import React from 'react';
import classes from './index.module.scss';

const LandaFinancingBackground = () => {
  return (
    <div className={classes.container}>
      <div className={classNames(classes.circle, classes.oneCircle)} />
      <div className={classNames(classes.circle, classes.twoCircle)} />
    </div>
  );
};
export default LandaFinancingBackground;
